import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoSafePipe } from './pipes/video-safe.pipe';
@NgModule({
  declarations: [VideoSafePipe],
  imports: [CommonModule],
  exports: [VideoSafePipe]
})
export class SharedModule {}